export default "__VITE_ASSET__7c564eec__"